"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _oxygenConfig = require("@8x8/oxygen-config");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var alignMap = {
  left: 'flex-start',
  right: 'flex-end'
};
function getModalFooterPadding(_ref) {
  var theme = _ref.theme,
    isSmall = _ref.isSmall,
    modalHasContent = _ref.modalHasContent;
  if (isSmall) {
    if (theme.footerPaddingSmall) {
      return theme.footerPaddingSmall;
    }

    // deprecated, should remain with `footerPaddingSmall` (might also deprecate with Novo in v2)
    return "".concat(theme.footerPaddingVertical, " ").concat(theme.footerPaddingSmallHorizontal);
  }
  if (!modalHasContent && theme.footerPaddingNoContent) {
    return theme.footerPaddingNoContent;
  }
  if (theme.footerPadding) {
    return theme.footerPadding;
  }

  // deprecated, should remain with only `footerPadding`
  return "".concat(theme.footerPaddingVertical, " ").concat(theme.footerPaddingHorizontal);
}
var FooterContainer = _styledComponents["default"].div.attrs(function (_ref2) {
  var testId = _ref2.testId;
  return _objectSpread({}, (0, _oxygenConfig.getTestAttributes)(testId));
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-flow: wrap;\n  justify-content: ", ";\n  gap: ", ";\n  padding: ", ";\n  box-shadow: ", ";\n"])), function (_ref3) {
  var align = _ref3.align;
  return alignMap[align] || align;
}, function (_ref4) {
  var theme = _ref4.theme,
    hasButtonSpacing = _ref4.hasButtonSpacing;
  return hasButtonSpacing ? theme.footerButtonSpacing : '0';
}, function (props) {
  return getModalFooterPadding(props);
}, function (_ref5) {
  var hasBorderTop = _ref5.hasBorderTop,
    theme = _ref5.theme;
  return hasBorderTop ? "inset ".concat(theme.footerShadowSize, " ").concat(theme.footerShadowColor) : 'none';
});
var _default = FooterContainer;
exports["default"] = _default;